import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment';
import Buefy from '@ntohq/buefy-next'
import '@ntohq/buefy-next/dist/buefy.css'
import '@mdi/font/css/materialdesignicons.css';
import './styles/global.scss'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { normalizeAuthToken } from '@/utils/helpers'


console.log("Environment:", process.env.NODE_ENV);

if (process.env.NODE_ENV === 'production') {
  console.log = function() {};
  console.debug = function() {};
  console.info = function() {};
  console.warn = function() {};
  console.error = function() {};
} else {
  console.log('Logging is enabled');
}

axios.interceptors.request.use((config) => {
  const authorization = config?.headers?.Authorization || config?.headers?.authorization

  if (typeof authorization === 'string') {
    const normalizedToken = normalizeAuthToken(authorization)

    if (config.headers.Authorization) {
      config.headers.Authorization = normalizedToken
    } else {
      config.headers.authorization = normalizedToken
    }
  }

  return config
})

const app = createApp(App);
app.use(VueCookies, { expires: '14d'});
app.use(Buefy, {
  defaultIconPack: 'mdi', // Use Material Design Icons
});
app.use(VueAxios, axios)

app.config.globalProperties.$moment=moment;

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(router);

app.mount('#app');
